export default "https://cdn-static.gokick.com/assets/3c8eadbe8dc90fc8bfe5d2560afe7db765946837/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";